var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWosPermissions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20409 -1963)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-20409 1963)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20403.941 1970.713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4045.262,4577.367l-.825.723a.973.973,0,0,1-1.4-.013.934.934,0,0,1,.125-1.39q4.32-3.848,8.645-7.689a.958.958,0,0,1,1.373,0q4.28,3.8,8.551,7.6a1.025,1.025,0,0,1,.18,1.462,1,1,0,0,1-1.441-.051c-.257-.219-.518-.431-.861-.718v1.055h-1.889v-.787c0-.564.011-1.127-.007-1.689a.671.671,0,0,0-.157-.441c-1.662-1.5-3.336-2.978-5.046-4.5-.227.19-.447.364-.658.551-1.436,1.275-2.876,2.549-4.3,3.841a.854.854,0,0,0-.253.557c-.016,2.458,0,4.917-.018,7.376,0,.343.131.412.435.41,1.841-.009,3.682,0,5.522,0h.478v1.789c-.138.008-.282.025-.427.025q-2.946,0-5.893,0a1.888,1.888,0,0,1-2.012-2.01c-.008-1.868,0-3.736,0-5.6v-.438Z",
    transform: "translate(4047.739 -4568.709)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3913.784,4712.826q-3.338,0-6.677,0a.9.9,0,0,1-.947-.507.873.873,0,0,1,.662-1.243,1.879,1.879,0,0,1,.287-.013c.9-.011.9-.01.9-.892,0-1.718.029-3.436-.013-5.152a1.681,1.681,0,0,1,1.652-1.665c2.8.048,5.606.016,8.409.017a1.454,1.454,0,0,1,1.555,1.574c0,1.883.008,3.765-.007,5.647,0,.375.1.511.488.491a2.8,2.8,0,0,1,.929.109.736.736,0,0,1,.529.831.826.826,0,0,1-.679.776,2.474,2.474,0,0,1-.451.023Q-3910.465,4712.828-3913.784,4712.826Zm.05-7.607c-1.166,0-2.334.012-3.5-.009-.352-.006-.487.087-.484.457.015,1.661.011,3.322,0,4.982,0,.311.086.433.422.432q3.543-.021,7.084,0c.3,0,.4-.078.4-.391q-.021-2.554,0-5.107c0-.3-.1-.372-.381-.369C-3911.372,4705.226-3912.553,4705.219-3913.734,4705.219Z",
    transform: "translate(3931.901 -4692.252)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3951.63,4667.279c-.424,0-.85,0-1.274,0-.371,0-.619-.158-.625-.549-.013-.889-.021-1.78,0-2.668.009-.382.277-.542.643-.54.767,0,1.535,0,2.3.012.674.007.858.187.866.848q.013,1.088.014,2.178c0,.578-.141.715-.734.721-.4,0-.794,0-1.192,0Z",
    transform: "translate(3961.308 -4655.704)",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWosPermissions);
export default __webpack_public_path__ + "static/media/icon-wos-permissions.5a046b60.svg";
export { ForwardRef as ReactComponent };